import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Button, TextField, Paper, Typography, FormGroup, FormControlLabel, InputLabel, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { authAPI } from "../services/AuthAPI";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import './edit_profile.css'

const EditProfile = ({ isMobile, closeNav }) => {
    const dispatch = useDispatch()
    const { isLoading, userData } = useSelector(state => state.user)
    const [changePassword, setChangePassword] = useState(false)

    const FormSchema = Yup.object().shape(
        changePassword
            ? {
                newPassword: Yup.string()
                    .min(5, "ป้อนรหัสผ่านอย่างน้อย 5 หลัก")
                    .max(255, "ป้อนรหัสผ่านไม่เกิน 255 หลัก")
                    .trim()
                    .required("ป้อนรหัสผ่านใหม่"),
                confirmNewPassword: Yup.string()
                    .oneOf([Yup.ref("newPassword")], "คุณต้องป้อนรหัสผ่านที่เหมือนกันสองครั้งเพื่อยืนยันรหัสผ่าน")
                    .required("ป้อนรหัสผ่านใหม่อีกครั้งเพื่อยืนยัน"),
                email: Yup.string()
                    .matches(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                    .trim()
                    .required("ป้อนที่อยู่อีเมลของคุณ")
            }
            : {
                email: Yup.string()
                    .matches(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                    .trim()
                    .required("ป้อนที่อยู่อีเมลของคุณ")
            }
    );

    const useStyles = makeStyles(theme => ({
        leftIcon: {
            marginRight: theme.spacing(1)
        },
        root: {
            padding: theme.spacing(4, 3)
        },
        container: {
            display: "block",
            flexWrap: "wrap"
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginTop: theme.spacing(1),
            width: 400
        },
        button: {
            marginTop: theme.spacing(2)
        },
        mt_1: {
            margin: theme.spacing(3)
        }
    }));

    const classes = useStyles();

    return (
        !isLoading && <Formik
            validationSchema={FormSchema}
            initialValues={{ email: userData ? userData.email || "" : "", newPassword: "", confirmNewPassword: "" }}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true)
                let form = new FormData()
                form.append("email", values.email)
                form.append("changePassword", changePassword)
                if (changePassword) {
                    form.append("newPassword", values.newPassword)
                    form.append("confirmNewPassword", values.confirmNewPassword)
                }
                Swal.fire({
                    title: "ใส่รหัสผ่านเก่า",
                    input: "password",
                    inputAttributes: {
                        autocapitalize: "off"
                    },
                    confirmButtonColor: "#6ab23a",
                    showCancelButton: true,
                    confirmButtonText: "OK!",
                    showLoaderOnConfirm: true,
                    preConfirm: (password) => {
                        try {
                            if (!password) throw { message: "Password ห้ามว่าง" }
                            form.append("password", password)
                            return authAPI.editUser(form)
                                .then(res => {
                                    if (res.status != 200) {
                                        throw new Error(res.message);
                                    }
                                    return res;
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(error.message);
                                });
                        } catch (error) {
                            Swal.showValidationMessage(error.message);
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then(result => {
                    setSubmitting(false)
                    Swal.fire({
                        icon: 'success',
                        confirmButtonColor: "#6ab23a",
                        text: `เราได้อัพเดตข้อมูลส่วนตัวของคุณเรียบร้อย`,
                        timer: 5000
                    })
                        .then(() => {
                            if (result.value.token) {
                                localStorage.setItem("Token", result.value.token)
                            }
                            dispatch({ type: "USER_UPDATE", payload: result.value.message })
                        })
                });
            }}
        >
            {({
                values,
                handleChange,
                isSubmitting,
                touched,
                errors,
            }) => (
                <Form className='container h-100vh' style={{ display: closeNav ? 'flex' : isMobile ? 'none' : '', marginTop: !isMobile ? 0 : '70px' }}>
                    <Paper className={`${classes.root} paper-root`} style={{ padding: '3%' }}>
                        <h3 style={{ fontSize: '2.375rem', marginBottom: '2%' }} className={`${classes.h3} h3`}>แก้ไขข้อมูลส่วนตัว</h3>
                        <Typography component="div" style={{ margin: '5px', marginTop: '3%', display: 'table-cell' }} className={`${classes.Typography} Typography`} >
                            <Typography component="div" variant="h5" style={{ width: '100%', display: 'flex', flexDirection: 'column' }} >สวัสดี นี่คือ {userData?.fullname}<Typography component="p" variant="h6" style={{ marginTop: '-8%', fontSize: '1rem' }} className={`${classes.Typography} p-Typography`}> <br></br>{userData?.PositionName}</Typography></Typography>
                        </Typography>
                        <TextField
                            label="อีเมล"
                            className={`${classes.textField} email-textField`}
                            helperText="e.g. name@comseven.com"
                            name={"email"}
                            value={values.email}
                            onChange={handleChange}
                        />
                        <FormGroup className={`${classes.mt_1} group-mt_1`}>
                            <InputLabel htmlFor="age-native-simple">
                                <strong>ต้องการแก้รหัสผ่านของคุณหรือไม่</strong>
                            </InputLabel>
                            <FormControlLabel control={<Checkbox checked={changePassword} onClick={() => { changePassword == false ? setChangePassword(true) : setChangePassword(false) }} />} label="ใช่" />
                            {/* <FormControlLabel control={<Checkbox checked={!changePassword} onClick={() => setChangePassword(false)} />} label="No" /> */}
                        </FormGroup>
                        {changePassword && <Typography component="div" style={{ display: 'flex', flexDirection: 'column' }}>
                            <TextField
                                label="รหัสผ่านใหม่"
                                type={'password'}
                                className={`${classes.textField} textField`}
                                name="newPassword"
                                value={values.newPassword}
                                onChange={handleChange}
                            />
                            <TextField
                                label="ยืนยันรหัสผ่านใหม่"
                                type={'password'}
                                className={`${classes.textField} textField`}
                                name="confirmNewPassword"
                                value={values.confirmNewPassword}
                                onChange={handleChange}
                            />
                        </Typography>}
                        <Typography component="div">
                            {errors.email && touched.email ? (
                                <div style={{ color: "#FF3333" }}>{errors.email}</div>
                            ) : null}
                            {changePassword && errors.newPassword && touched.newPassword ? (
                                <div style={{ color: "#FF3333" }}>{errors.newPassword}</div>
                            ) : null}
                            {changePassword && errors.confirmNewPassword && touched.confirmNewPassword ? (
                                <div style={{ color: "#FF3333" }}>{errors.confirmNewPassword}</div>
                            ) : null}
                        </Typography>
                        <Button
                            type="submit"
                            disabled={isSubmitting}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', marginTop: '4%'
                            }}
                            className={classes.button}
                        >
                            บันทึก
                        </Button>
                    </Paper>
                </Form>)}
        </Formik>
    )
}
export default EditProfile